<template>
  <div class="backdrop">
    <div class="backdrop-top" :style="[stocktaking_info.status == 0 ? {'height': 'calc(100% - 58px)'} : {'height': '100%'}]">
      <div class="title-box">
        <img src="../../../assets/images/return-white.png" @click="$router.go(-1)"><span>资产盘点单详情</span>
      </div>
      <div class="header-wrapper">
        <div class="header-box">
          <div class="mar_bot title">{{stocktaking_info.stocktaking_title}}</div>
          <div class="layout mar_bot">
            <div class="flex-1"><label>创建人</label>{{stocktaking_info.create_member_name}}</div>
            <div class="flex-1"><label>盘点总数</label>{{total_rows}}</div>
          </div>
          <div class="layout mar_bot">
            <div class="flex-1"><label>创建时间</label>{{stocktaking_info.create_time_info}}</div>
            <div class="flex-1"><label>盘点仓库</label>{{stocktaking_info.storage_name}}</div>
          </div>
          <div class="layout">
            <div class="flex-1"><label>入账时间</label>{{stocktaking_info.enter_time_info}}</div>
          </div>
        </div>
      </div>
      <div class="center-wrapper">
        <div class="center-select layout">
          <div class="flex-1" @click="areaClick">{{area_name}}<img src="../../../assets/images/material-crudejt-down.png"></div>
          <div class="flex-1" @click="userClick">{{keeper_member_name}}<img src="../../../assets/images/material-crudejt-down.png"></div>
          <div class="select-empty" @click="clearSearch()"><img src="../../../assets/images/repairman-search-close.png"></div>
        </div>
        <div class="layout center-box">
          <div class="flex-1" @click="check_status=0" :class="check_status == 0 ? 'blue':' '">
            <label>待盘<img v-if="check_status == 0" src="../../../assets/images/asset-right_jt_blue.png"><img v-else src="../../../assets/images/asset-right_jt.png"></label>
            <div class="num">{{stocktaking_info.wait_rows}}</div>
          </div>
          <div class="flex-1" @click="check_status=1" :class="check_status == 1 ? 'blue':' '">
            <label>盘平<img v-if="check_status == 1" src="../../../assets/images/asset-right_jt_blue.png"><img v-else src="../../../assets/images/asset-right_jt.png"></label>
            <div class="num">{{stocktaking_info.balance_rows}}</div>
          </div>
          <div class="flex-1" @click="check_status=2" :class="check_status == 2 ? 'blue':' '">
            <label>盘盈<img v-if="check_status == 2" src="../../../assets/images/asset-right_jt_blue.png"><img v-else src="../../../assets/images/asset-right_jt.png"></label>
            <div class="num">{{stocktaking_info.profit_rows}}</div>
          </div>
          <div class="flex-1" @click="check_status=3" :class="check_status == 3 ? 'blue':' '">
            <label>盘亏<img v-if="check_status == 3" src="../../../assets/images/asset-right_jt_blue.png"><img v-else src="../../../assets/images/asset-right_jt.png"></label>
            <div class="num">{{stocktaking_info.loss_rows}}</div>
          </div>
        </div>
      </div>
      <div class="list-wrapper">
        <div class="list-li" v-for="(detail, detail_key) in stocktaking_info.goods" :key="detail_key" v-if="detail.stocktake_status == check_status" @click="toDetail(detail_key)">
          <div class="title">{{detail.goods_name}}
            <span v-if="detail.stocktake_status == 0">{{detail.old_status_info}}</span>
            <span v-else>{{detail.new_status_info}}</span>
            <img class="more" src="../../../assets/images/asset-more.png">
          </div>
          <div class="code"><label>资产编码</label>{{detail.asset_num}}</div>
          <div class="tag">
            <span style="padding: 0" v-if="detail.old_keeper_member_name !== '' || detail.new_keeper_member_name !== ''">
              <span v-if="detail.stocktake_status == 0">{{detail.old_keeper_member_name}}</span>
              <span v-else>{{detail.new_keeper_member_name}}</span>
            </span>
            <span style="padding: 0" v-if="detail.old_area_name !== '' || detail.new_area_name !== ''">
              <span v-if="detail.stocktake_status == 0">{{detail.old_area_name}}</span>
              <span v-else>{{detail.new_area_name}}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-wrapper" v-if="stocktaking_info.status == 0 && come_from_approval != 1">
      <div @click="$router.push({name: 'AssetStocktakingProfit', query: {stocktaking_id: stocktaking_id}})">盘盈</div>
      <div @click="$router.push({name: 'AssetStocktakingEnterCode', query: {stocktaking_id: stocktaking_id}})">录码</div>
      <div @click="scanCode">扫码</div>
    </div>
    <!-- 选择区域 -->
    <div class="select-mask" v-if="areaPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择区域<img class="close-mask" @click="areaClose" src="../../../assets/images/close.png"></div>
          <el-tree :data="areaData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectArea"></el-tree>
        </div>
      </div>
    </div>

    <!-- 选择使用人 -->
    <div class="select-mask" v-if="userPopup">
      <div class="select-mask-blank" @click="clickBlank"></div>
      <div class="select-mask-inner">
        <div class="select-mask-content">
          <div class="head-mask">选择使用人<img class="close-mask" @click="userClose" src="../../../assets/images/close.png"></div>
          <div class="search-box" style="padding: 15px 0">
            <input type="text" v-model="userKeywords" placeholder="请输入姓名/手机号" @keyup.enter="findUser" @input="findUser">
          </div>
          <el-tree :data="userData" :props="defaultProps" :expand-on-click-node="false" node-key="id" @node-click="selectKeeper"></el-tree>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'materialAdd',
  metaInfo: {
    title: '资产盘点单详情'
  },
  data () {
    return {
      stocktaking_id: 0,
      stocktaking_info: [],
      total_rows: 0, // 盘点总数，不随搜索条件而变化，进入页面第一次获取盘点单信息时可获取
      check_status: 0,
      area_id: 0,
      area_name: '区域',
      keeper_member_id: 0,
      keeper_member_name: '使用人',
      areaPopup: false, // 区域
      areaData: [],
      userPopup: false, // 使用人
      userData: [],
      allUserData: [],
      userKeywords: '',
      input_asset_num: '', // 盘点资产编码（扫码或录码结果）
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      come_from_approval: 0 // 审批页面调过来时传come_from_approval=1,不展示操作按钮
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    this.stocktaking_id = this.$route.query.stocktaking_id
    if (this.$route.query.come_from_approval) {
      this.come_from_approval = this.$route.query.come_from_approval
    }
    this.getStocktakingInfo(1)
    this.getAreaTree()
    this.getUserTree()

    let url = window.location.href.split('#')[0]
    this.axios.post('/wechat/index/getticket', {
      url,
      village_id: this.villageId
    }).then((res) => {
      this.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.data.signature, // 必填，签名
        jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表 hideMenuItems
      })
      this.wx.ready(() => {
        console.log('成功')
      })
      this.wx.error(function (res) {
        console.log('失败')
      })
    })
  },
  methods: {
    getAreaTree () {
      this.axios.post('/wechat/basic_info/getAreaTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.areaData = res.data.data
        }
      })
    },
    getUserTree () {
      this.axios.post('/wechat/basic_info/getVillageMemberTree', {
        member_id: this.memberId,
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          this.allUserData = res.data.data
          this.userData = res.data.data
        }
      })
    },
    findUser () {
      this.userData = []
      var keywords = this.userKeywords
      let that = this
      this.allUserData.forEach(function (detail) {
        if (detail.label.indexOf(keywords) !== -1) {
          that.userData.push(detail)
        }
      })
    },
    // 获取盘点单信息
    getStocktakingInfo (type = 0) {
      this.axios.post('/wechat/stocktaking/getStocktakingInfo', {
        member_id: this.memberId,
        village_id: this.villageId,
        stocktaking_id: this.stocktaking_id,
        area_id: this.area_id,
        keeper_member_id: this.keeper_member_id
      }).then((res) => {
        if (res.data.status === 1) {
          this.stocktaking_info = res.data.data.stocktaking_info
          if (type === 1) { // 进页面第一次获取不带搜索条件的盘点单信息
            this.total_rows = this.stocktaking_info.total_rows
          }
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    },
    // 详情
    toDetail (key) {
      if (this.come_from_approval === 1) {
        return false
      }
      var detail = this.stocktaking_info['goods'][key]
      if (this.stocktaking_info.handwork_allow === 0 && detail.stocktake_status === 0) {
        // 不允许手动盘点的单子，待盘不能点入
        return false
      }
      var showStocktakeBtn = 0
      if (this.stocktaking_info.status === 0 && !this.stocktaking_info.approval) {
        showStocktakeBtn = 1
      }
      this.$router.push({name: 'AssetStocktakingDetail', query: {stocktaking_id: this.stocktaking_id, show_stocktake_btn: showStocktakeBtn, detail: JSON.stringify(detail)}})
    },
    // 点击区域
    areaClick () {
      this.areaPopup = true
    },
    // 关闭区域弹出
    areaClose () {
      this.areaPopup = false
    },
    // 点击使用人
    userClick () {
      this.userPopup = true
    },
    // 关闭使用人弹出
    userClose () {
      this.userPopup = false
    },
    // 点击空白地方关闭
    clickBlank () {
      this.userPopup = false
      this.areaPopup = false
    },
    selectArea (data) {
      this.area_id = data.id
      this.area_name = data.label
      this.clickBlank()
      this.getStocktakingInfo()
    },
    selectKeeper (data) {
      this.keeper_member_id = data.id
      this.keeper_member_name = data.label.split('-')[0]
      this.clickBlank()
      this.getStocktakingInfo()
    },
    clearSearch () {
      this.area_id = 0
      this.area_name = '区域'
      this.keeper_member_id = 0
      this.keeper_member_name = '使用人'
      this.getStocktakingInfo()
    },
    // 扫码
    scanCode () {
      let that = this
      this.wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          var result = res.resultStr // 当needResult 为 1 时，扫码返回的结果
          var str = result.split(',')
          that.input_asset_num = str[1]
          that.checkCode()
        }
      })
    },
    // 资产编码校验
    checkCode () {
      if (this.input_asset_num === '') {
        this.$toast({
          message: '未获取到资产编码',
          duration: 2000
        })
        return false
      }
      // 判断资产是否存在
      this.axios.post('/wechat/asset/assetDetail', {
        member_id: this.memberId,
        village_id: this.villageId,
        asset_num: this.input_asset_num
      }).then((res) => {
        if (res.data.status === 1) {
          var assetInfo = res.data.data
          if (assetInfo.status < 0) {
            this.$messagebox({
              message: '该资产已报废，无法盘点',
              closeOnClickModal: false,
              showCancelButton: false,
              confirmButtonText: '确定'
            })
            return false
          }
          // 判断资产是否在盘点单内
          this.axios.post('/wechat/stocktaking/getStocktakingInfo', {
            member_id: this.memberId,
            village_id: this.villageId,
            stocktaking_id: this.stocktaking_id,
            asset_id: assetInfo.asset_id
          }).then((res2) => {
            if (res2.data.status === 1) {
              var stocktakingInfo = res2.data.data.stocktaking_info
              if (assetInfo.storage_id !== stocktakingInfo.storage_id) {
                this.$messagebox({
                  message: '该资产不属于盘点仓库，无法盘点',
                  closeOnClickModal: false,
                  showCancelButton: false,
                  confirmButtonText: '确定'
                })
                return false
              }
              if (stocktakingInfo.goods.length > 0) {
                // 在盘点单内
                var detail = stocktakingInfo.goods[0]
                this.$router.push({name: 'AssetStocktakingDetail', query: {stocktaking_id: this.stocktaking_id, show_stocktake_btn: 1, detail: JSON.stringify(detail)}})
              } else {
                // 不在盘点单内
                this.$messagebox({
                  message: '该资产不在本次盘点范围，是否继续盘点',
                  closeOnClickModal: false,
                  showCancelButton: true,
                  confirmButtonText: '盘点'
                }).then(action => {
                  if (action === 'confirm') { // 确认的回调
                    var detail = {}
                    detail.asset_id = assetInfo.asset_id
                    detail.asset_num = assetInfo.asset_num
                    detail.goods_name = assetInfo.goods_name
                    detail.stocktake_status = 0
                    detail.old_area_id = assetInfo.area_id
                    detail.old_area_name = assetInfo.area_name
                    detail.old_keeper_member_id = assetInfo.keeper_member_id
                    detail.old_keeper_member_name = assetInfo.keeper_member_name
                    detail.old_status = assetInfo.status
                    detail.old_status_info = assetInfo.status_info
                    this.$router.push({name: 'AssetStocktakingDetail', query: {stocktaking_id: this.stocktaking_id, show_stocktake_btn: 1, detail: JSON.stringify(detail)}})
                  }
                })
              }
            }
          }).catch(() => {
            this.$toast({
              message: '网络错误',
              duration: 5000
            })
          })
        } else {
          this.$messagebox({
            message: '未找到编号' + this.input_asset_num + '资产，是否增加盘盈',
            closeOnClickModal: false,
            showCancelButton: true,
            confirmButtonText: '盘盈'
          }).then(action => {
            if (action === 'confirm') { // 确认的回调
              this.$router.push({name: 'AssetStocktakingProfit', query: {stocktaking_id: this.stocktaking_id, code_asset_num: this.input_asset_num}})
            }
          })
        }
      }).catch(() => {
        this.$toast({
          message: '网络错误',
          duration: 5000
        })
      })
    }
  }
}
</script>
<style scoped>
.backdrop {
  background-color: #f6f6f6;
  overflow: hidden;
}
.backdrop-top {
  height: calc(100% - 58px);
  overflow-y: auto;
}
.title-box {
  background-color: #7090fd;
  color: #ffffff;
}
.header-wrapper {
  background-color: #7090fd;
  padding: 5px 10px 15px 10px;
}
.header-wrapper .header-box {
  background-color: #8ca6fd;
  border-radius: 5px;
  font-size: 12px;
  color: #ffffff;
  padding: 10px;
}
.header-wrapper .header-box .title {
  font-size: 16px;
}
.header-wrapper .header-box .layout .flex-1 label {
  color: #b2cfff;
  display: inline-block;
  width: 64px;
}
.center-wrapper {
  background-color: #ffffff;
  padding: 10px;
  margin-bottom: 8px;
}
.center-wrapper .center-select {
  padding-bottom: 10px;
  font-size: 15px;
}
.center-wrapper .center-select img {
  width: 10px;
  height: 10px;
  padding-left: 5px;
}
.center-wrapper .center-select {
  position: relative;
}
.center-wrapper .center-select .select-empty {
  width: 50px;
  text-align: right;
}
.center-wrapper .center-select .select-empty img {
  width: 18px;
  height: 18px;
}
.center-wrapper .center-box {
  background-color: #f6f6f6;
  padding: 10px;
}
.center-wrapper .center-box .flex-1 {
  text-align: center;
}
.center-wrapper .center-box label {
  color: #999;
  font-size: 14px;
}
.center-wrapper .center-box label img {
  width: 9px;
  height: 9px;
  padding-left: 3px;
}
.center-wrapper .center-box .num {
  font-size: 16px;
  margin-top: 10px;
  font-weight: 600;
}
.center-wrapper .center-box .blue label {
  color: #7090fd !important;
}
.center-wrapper .center-box .blue .num {
  color: #7090fd !important;
}
.list-wrapper {
  overflow-y: auto;
}
.list-wrapper .list-li {
  background-color: #ffffff;
  margin-bottom: 8px;
  padding: 10px;
}
.list-wrapper .list-li:last-child {
  margin-bottom: 0;
}
.list-wrapper .list-li .title {
  font-size: 15px;
  font-weight: 600;
  position: relative;
}
.list-wrapper .list-li .title span {
  font-weight: normal;
  background-color: #7090fd;
  color: #ffffff;
  padding: 2px 3px;
  margin-left: 5px;
  font-size: 12px;
  border-radius: 2px;
}
.list-wrapper .list-li .title .more {
  width: 16px;
  height: 16px;
  position: absolute;
  top: 2px;
  right: 0;
}
.list-wrapper .list-li .code {
  font-size: 13px;
  padding: 6px 0;
}
.list-wrapper .list-li .code label {
  color: #999;
  padding-right: 5px;
}
.list-wrapper .list-li .tag span {
  font-size: 13px;
  background-color: #c9ddfe;
  color: #7090fd;
  margin-left: 8px;
  padding: 2px 5px 1px 5px;
  border-radius: 2px;
}
.list-wrapper .list-li .tag span:first-child {
  margin-left: 0;
}
.footer-wrapper {
  width: 100%;
  height: 50px;
  border: none;
  font-size: 16px;
  letter-spacing: 2px;
  color: #313131;
  display: flex;
  background-color: #ffffff;
  margin-top: 8px;
}
.footer-wrapper div {
  flex: 1;
  line-height: 50px;
  text-align: center;
}
.layout {
  display: flex;
}
.layout .flex-1 {
  flex: 1;
}
.mar_bot {
  margin-bottom: 8px;
}
.select-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.select-mask .select-mask-blank {
  width: 100%;
  height: 100%;
}
.select-mask .select-mask-inner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #ffffff;
  font-size: 15px;
  height: 300px;
  overflow-y: auto;
}
.select-mask .select-mask-inner .select-mask-content {
  padding: 0 15px;
}
.select-mask .select-mask-inner .head-mask {
  text-align: center;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
}
.select-mask .select-mask-inner .head-mask .close-mask {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 12px;
  right: 10px;
}
.select-mask .select-mask-inner .select-mask-content .level {
  border-bottom: 1px solid #f6f6f6;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  position: relative;
}
.select-mask .select-mask-inner .select-mask-content label {
  display: block;
  border-bottom: 1px solid #f6f6f6;
  padding: 5px 15px;
}
>>>
.mint-switch-core {
  width: 42px;
  height: 22px;
}
>>>
.mint-switch-core::before {
  width: 40px;
  height: 20px;
}
>>>
.mint-switch-core::after {
  width: 20px;
  height: 20px;
}
>>>
.el-tree-node__expand-icon {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/AssetStocktaking/AssetStocktakingInfo.vue